import { useTranslation } from "react-i18next";
import { useGetGlobalQuery, useGetHeaderQuery } from "../generated/graphql";

export const useGetGlobalSettings = () => {
  const { i18n } = useTranslation();
  const { data } = useGetGlobalQuery({
    fetchPolicy: "cache-and-network",
    variables: {
      locale: i18n.language,
    },
  });

  const { data: headerData } = useGetHeaderQuery({
    fetchPolicy: "cache-and-network",
    variables: {
      locale: i18n.language,
    },
  });

  return {
    location: data?.global?.location,
    mySereniLink: data?.global?.mySereniLink,
    showMySereni: data?.global?.showMySereni,
    showEventsBlock: data?.global?.showEventsBlock,
    showJobsBlock: data?.global?.showJobsBlock,
    showFacebookFooterIcon: data?.global?.showFacebookFooterIcon,
    showInstagramFooterIcon: data?.global?.showInstagramFooterIcon,
    showLinkedinFooterIcon: data?.global?.showLinkedinFooterIcon,
    facebookFooterLink: data?.global?.facebookFooterLink,
    instagramFooterLink: data?.global?.instagramFooterLink,
    linkedinFooterLink: data?.global?.linkedinFooterLink,
    showCollaborationBlock: data?.global?.showCollaborationBlock,
    showFirstButton: headerData?.header?.showFirstButton,
    firstButtonText: headerData?.header?.firstButtonText,
    firstButtonLink: headerData?.header?.firstButtonLink,
    showSecondButton: headerData?.header?.showSecondButton,
    secondButtonText: headerData?.header?.secondButtonText,
    secondButtonLink: headerData?.header?.secondButtonLink,
  };
};
